import React, { useState, useCallback, useEffect } from "react";
import DataTable from '../DataTable/DataTable';
import workReports from "../../apis/requisitionReports/workReport";
import "./requisitionReports.css";
import config from "../../Config.json";
import {
  NotificationManager,
} from "react-notifications";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const stylesSX = {
  odd: {
    background: "#F6F6F6 !important",
  },
  even: {
    background: "#ffffff !important", // corrected the typo "#fffff"
  },
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  }),
  waitingText: {
    marginLeft: "5px",
  },
};

const WorkReport = (props) => {
  const {
    userType,
    userIdType,
    userRecruitmentpartnerId,
    triggerAction,
    resetTrigger,
    startSelectedDate,
    endSelectedDate,
    additionalFilterData
  } = props;

  const [isSearching, setIsSearching] = useState(true);
  const [takeNumberOfResult, setTakeNumberOfResult] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalResult, setTotalResult] = useState(0);
  const [isExporting, setIsExporting] = useState(false);
  const [dataResult, setDataResult] = useState([]);

  // Track previous date and filter values to detect changes
  const [prevStartDate, setPrevStartDate] = useState(null);
  const [prevEndDate, setPrevEndDate] = useState(null);
  const [prevFilterData, setPrevFilterData] = useState({});

  // Define columns for the DataTable
  const columns = [
    {
      accessorKey: "name",
      header: "Candidate Name",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "email",
      header: "Email",
      width: "300px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "reqreferenceId",
      header: "Reference ID",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "primarySkill",
      header: "Primary Skill",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "division",
      header: "Division",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "jobpriority",
      header: "Job Priority",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "client",
      header: "Client",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "clientJobId",
      header: "Client ID",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "recruiter",
      header: "Recruiter",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "recruiterLeader",
      header: "Recruiter Leader",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "currentStatus",
      header: "Current Status",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "teamLeader",
      header: "Team Leader",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "recruitmentLeader",
      header: "Recruitment Leader",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "city",
      header: "City",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "state",
      header: "State",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "country",
      header: "Country",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "status",
      header: "Status",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "displayDate",
      header: "Status Change Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
      cell: ({ row }) => {
        const { displayDate } = row.original;
        if (!displayDate) return "N/A";
        const date = new Date(displayDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "submissionDate",
      header: "Submission Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
      cell: ({ row }) => {
        const { submissionDate } = row.original;
        if (!submissionDate) return "N/A";
        const date = new Date(submissionDate);
        if (isNaN(date.getTime())) return "N/A";
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "interviewDate",
      header: "Interview Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
      cell: ({ row }) => {
        const { interviewDate } = row.original;
        if (!interviewDate) return "N/A";
        const date = new Date(interviewDate);
        if (isNaN(date.getTime())) return "N/A";
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "selectedDate",
      header: "Selected Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
      cell: ({ row }) => {
        const { selectedDate } = row.original;
        if (!selectedDate) return "N/A";
        const date = new Date(selectedDate);
        if (isNaN(date.getTime())) return "N/A";
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "startDate",
      header: "Start Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
      cell: ({ row }) => {
        const { startDate } = row.original;
        if (!startDate) return "N/A";
        const date = new Date(startDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "offerRealeaseDate",
      header: "Offer Release Date",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
      cell: ({ row }) => {
        const { offerRealeaseDate } = row.original;
        if (!offerRealeaseDate) return "N/A";
        const date = new Date(offerRealeaseDate);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      },
    },
    {
      accessorKey: "salary",
      header: "Salary",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "minimumBillRate",
      header: "Minimum Bill Rate",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "maximumBillRate",
      header: "Maximum Bill Rate",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "currency",
      header: "Currency",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "fee",
      header: "Fee",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "previouslyHired",
      header: "Previously Hired",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "placementType",
      header: "Placement Type",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    },
    {
      accessorKey: "source",
      header: "Source",
      width: "180px",
      enableSorting: true,
      enableFiltering: false,
    }
  ];

  // Format date function
  const formatDateOnly = useCallback((dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; // Get only the YYYY-MM-DD part
  }, []);

  // Excel export function
  const callApiToGenerateExcel = useCallback(async () => {
    setIsExporting(true);

    const maxSize = config.MAX_SIZE 
    let end = Math.ceil(totalResult / maxSize);
    let pageStart = 1;
    let exportArr = [];

    try {
      for (let start = 0; start < end; start++) {
        let payload = {
          orgId: userRecruitmentpartnerId,
          isExport: true,
          page: pageStart,
          size: maxSize,
          formattedDatestart: formatDateOnly(startSelectedDate),
          formattedDateend: formatDateOnly(endSelectedDate),
          userId: userIdType,
          role: userType,
          additionalFilter: {
            clientName: additionalFilterData.clientName,
            divisionId: additionalFilterData.divisionId,
            interview_date: additionalFilterData.interview_date,
            selected_date: additionalFilterData.selected_date,
            start_date: additionalFilterData.start_date,
            offer_date: additionalFilterData.offer_release_date,
            clientJobId: additionalFilterData.clientJobId,
            teamId: additionalFilterData.teamId || []
          }
        };

        const allDetails = await workReports(payload);

        allDetails.data.forEach((element) => {
          let data = {
            "Candidate Name": element.name,
            Email: element.email,
            "Reference ID": element.reqreferenceId,
            "Primary Skill": element.primarySkill,
            Division: element.division,
            "Job Priority": element.jobpriority,
            Client: element.client,
            "Client ID": element.clientJobId,
            Recruiter: element.recruiter,
            "Recruiter Leader": element.recruiterLeader,
            "Current Status": element.currentStatus,
            "teamLeader": element.teamLeader,
            "recruitmentLeader": element.recruitmentLeader,
            Country: element.country?.[0] || "",
            State: element.state?.[0] || "",
            City: element.city?.[0] || "",
            Status: element.status,
            "Status Change Date": element.displayDate,
            "Start Date": element.startDate,
            "Offer Release Date": element.offerRealeaseDate,
            "Interview Date": element.interviewDate,
            "Submission Date": element.submissionDate,
            "Selected Date": element.selectedDate,
            Salary: element.salary,
            "Minimum Bill Rate": element.minimumBillRate,
            "Maximum Bill Rate": element.maximumBillRate,
            Currency: element.currency,
            Fee: element.fee,
            "Previously Hired": element.previouslyHired,
            "Placement Type": element.placementType,
            Source: element.source,
          };
          exportArr.push(data);
        });

        pageStart = pageStart + maxSize;
      }

      if (exportArr.length === 0) {
        NotificationManager.error("No data present", "Error", 10000);
        setIsExporting(false);
        return;
      }
      // Lazy load XLSX only when needed for export
      const { utils, writeFile } = await import("xlsx");
      // ✅ Create single sheet
      const ws = utils.json_to_sheet(exportArr);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Work Report");

      writeFile(wb, "WorkReport.xlsx");

    } catch (error) {
      console.error("Error exporting Work Report:", error);
      NotificationManager.error("Failed to export", "Error", 10000);
    } finally {
      setIsExporting(false);
    }
  }, [
    totalResult,
    userRecruitmentpartnerId,
    startSelectedDate,
    endSelectedDate,
    userIdType,
    userType,
    additionalFilterData,
    formatDateOnly,
  ]);

  useEffect(() => {
    if (triggerAction) {
      callApiToGenerateExcel();
      resetTrigger();
    }
  }, [triggerAction, resetTrigger, callApiToGenerateExcel]);

  // Search function without debounce
  const performSearch = useCallback(async (
    userRecruitmentpartnerId,
    pageNumber,
    takeNumberOfResult,
    startSelectedDate,
    endSelectedDate,
    userId,
    additionalFilterData
  ) => {
    let payload = {
      orgId: userRecruitmentpartnerId,
      page: pageNumber,
      size: takeNumberOfResult,
      formattedDatestart: formatDateOnly(startSelectedDate),
      formattedDateend: formatDateOnly(endSelectedDate),
      isExport: false,
      userId: userId,
      role: userType,
      additionalFilter: {
        clientName: additionalFilterData.clientName,
        divisionId: additionalFilterData.divisionId,
        interview_date: additionalFilterData.interview_date,
        selected_date: additionalFilterData.selected_date,
        start_date: additionalFilterData.start_date,
        offer_date: additionalFilterData.offer_release_date,
        clientJobId: additionalFilterData.clientJobId,
        teamId: additionalFilterData.teamId || []
      }
    };

    try {
      const search = await workReports(payload);

      if (search.data.length <= 0) {
        setDataResult(search.data);
        setTotalResult(0);
        setIsSearching(false);
      }
      if (search.data.length > 0) {
        setDataResult(search.data);
        if (search.totalCount[0].total)
          setTotalResult(search.totalCount[0].total);
        setIsSearching(false);
      }
    } catch (error) {
      console.error("Error fetching work reports:", error);
      setDataResult([]);
      NotificationManager.error("Error fetching data", "Error", 10000);
      setIsSearching(false);
    }
  }, [formatDateOnly, userType]);

  // Handle page change
  const handlePageChange = (newPage, newPageSize) => {
    setPageNumber(newPage);
    if (newPageSize && newPageSize !== takeNumberOfResult) {
      setTakeNumberOfResult(newPageSize);
    }
  };

  // Handle page size change
  const handlePageSizeChange = (newPageSize) => {
    setTakeNumberOfResult(newPageSize);
    setPageNumber(1);
  };

  // Handle filter change (if needed for server-side filtering)
  // Handle filter change (if needed for server-side filtering)


  // Check if dates or filters have changed
  useEffect(() => {
    // Check if dates have changed
    const datesChanged =
      prevStartDate !== startSelectedDate ||
      prevEndDate !== endSelectedDate;

    // Check if filters have changed
    const filtersChanged = JSON.stringify(prevFilterData) !== JSON.stringify(additionalFilterData);

    // Update previous values
    setPrevStartDate(startSelectedDate);
    setPrevEndDate(endSelectedDate);
    setPrevFilterData({ ...additionalFilterData });

    // Reset to page 1 if dates or filters changed
    if (datesChanged || filtersChanged) {
      setPageNumber(1);
      setPrevStartDate(startSelectedDate);
      setPrevEndDate(endSelectedDate);
      setPrevFilterData({ ...additionalFilterData });
    }
  }, [startSelectedDate, endSelectedDate, additionalFilterData]);

  useEffect(() => {
    if (!startSelectedDate || !endSelectedDate) {
      NotificationManager.error("Please enter a valid date", "Error", 10000);
      return;
    }

    // When any dependency changes, schedule a search.
    setIsSearching(true);
    setDataResult([]);

    const timeoutId = setTimeout(() => {
      performSearch(
        userRecruitmentpartnerId,
        pageNumber,
        takeNumberOfResult,
        startSelectedDate,
        endSelectedDate,
        userIdType,
        additionalFilterData
      );
    }, 1000); // 1000ms debounce delay

    // Cleanup cancels the pending search if dependencies change quickly.
    return () => clearTimeout(timeoutId);
  }, [
    pageNumber,
    takeNumberOfResult,
    startSelectedDate,
    endSelectedDate,
    additionalFilterData,
    userRecruitmentpartnerId,
    userIdType,
    performSearch
  ]);

  return (
    <>
      <Backdrop sx={stylesSX.backdrop} open={isExporting}>
        <CircularProgress color="inherit" />
        <Typography sx={stylesSX.waitingText}>
          {" "}
          Please wait ...
        </Typography>
      </Backdrop>

      <DataTable
        data={dataResult}
        columns={columns}
        isLoading={isSearching}
        totalRecords={totalResult}
        currentPage={pageNumber}
        pageSize={takeNumberOfResult}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        enableFiltering={false}
        enablePagination={true}
        enableSorting={false}
        pageSizeOptions={[10, 20, 50, 100]}
        isServerSide={true}
        className="kendo_reports"
        noDataText="No results found !"
      />
    </>
  );
};

export default WorkReport;

